import { MACRO_KEY } from "../../defaults";

import TooltipAndFootnotesIcon from "./icons/TooltipAndFootnotes";
import SpacerAndDividerIcon from "./icons/SpacerAndDivider";
import AnnouncementsIcon from "./icons/Announcements";
import ButtonInlineIcon from "./icons/ButtonInline";
import TextAndTitleIcon from "./icons/TextAndTitle";
import ImageSliderIcon from "./icons/ImageSlider";
import CountdownIcon from "./icons/Countdown";
import ButtonIcon from "./icons/Button";
import CardsIcon from "./icons/Cards";
import HTMLIcon from "./icons/HTML";
import PanelIcon from "./icons/Panel";
import TabsIcon from "./icons/Tabs";

import OtherModulesIcon from "./icons/OtherModules";
import OverviewIcon from "./icons/Overview";

import NewsIcon from "./icons/News";
import PagesIcon from "./icons/Pages";
import SpacesIcon from "./icons/Spaces";
import PeopleIcon from "./icons/People";
import OrgChartIcon from "./icons/OrgChart";
import RecentlyActiveIcon from "./icons/RecentlyActive";
import NewStartersIcon from "./icons/NewStarters";
import UpcomingBirthdaysIcon from "./icons/UpcomingBirthdays";
import WorkAnniversaryIcon from "./icons/WorkAnniversary";

import HelpCenter from "./help-center/icons/HelpCenter";

export const HELP_CENTER = {
  id: crypto.randomUUID(),
  label: "Help center",
  Icon: HelpCenter,
  key: "help-center",
};

export const MACRO_CATEGORIES = {
  UNCATEGORIZED: "uncategorized",
  PAGE_BUILDER: "page-builder",
  CONFLUENCE_CONTENT: "confluence-content",
  TEAMS_AND_ACTIVITY: "teams-and-activity",
};

export const MACRO = (t) => ({
  [MACRO_KEY.OVERVIEW_KEY]: {
    id: crypto.randomUUID(),
    label: t("overview-uppercase"),
    Icon: OverviewIcon,
    key: MACRO_KEY.OVERVIEW_KEY,
    category: MACRO_CATEGORIES.UNCATEGORIZED,
  },
  [MACRO_KEY.TEXT_AND_TITLE]: {
    id: crypto.randomUUID(),
    label: t("text-and-title"),
    Icon: TextAndTitleIcon,
    key: MACRO_KEY.TEXT_AND_TITLE,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.CARDS]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.cards"),
    Icon: CardsIcon,
    key: MACRO_KEY.CARDS,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.BUTTON]: {
    id: crypto.randomUUID(),
    label: t("button"),
    Icon: ButtonIcon,
    key: MACRO_KEY.BUTTON,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.PANEL_SIMPLE]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.panels"),
    Icon: PanelIcon,
    key: MACRO_KEY.PANEL_SIMPLE,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.COUNTDOWN]: {
    id: crypto.randomUUID(),
    label: t("countdown"),
    Icon: CountdownIcon,
    key: MACRO_KEY.COUNTDOWN,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.ANNOUNCEMENTS]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.announcements"),
    Icon: AnnouncementsIcon,
    key: MACRO_KEY.ANNOUNCEMENTS,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.SPACER_AND_DIVIDER]: {
    id: crypto.randomUUID(),
    label: t("divider"),
    Icon: SpacerAndDividerIcon,
    key: MACRO_KEY.SPACER_AND_DIVIDER,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.TABS]: {
    id: crypto.randomUUID(),
    label: t("tabs"),
    Icon: TabsIcon,
    key: MACRO_KEY.TABS,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.HTML]: {
    id: crypto.randomUUID(),
    label: "HTML",
    Icon: HTMLIcon,
    key: MACRO_KEY.HTML,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.IMAGE_SLIDER]: {
    id: crypto.randomUUID(),
    label: t("image-slider"),
    Icon: ImageSliderIcon,
    key: MACRO_KEY.IMAGE_SLIDER,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.PANEL_ADVANCED]: {
    id: crypto.randomUUID(),
    label: t("advanced-panels"),
    Icon: PanelIcon,
    key: MACRO_KEY.PANEL_ADVANCED,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.ADVANCED_TABS_GROUP]: {
    id: crypto.randomUUID(),
    label: t("advanced-tabs"),
    Icon: TabsIcon,
    key: MACRO_KEY.ADVANCED_TABS_GROUP,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.TOOLTIPS_AND_FOOTNOTES]: {
    id: crypto.randomUUID(),
    label: t("footnotes-and-tooltips"),
    Icon: TooltipAndFootnotesIcon,
    key: MACRO_KEY.TOOLTIPS_AND_FOOTNOTES,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.BUTTON_INLINE]: {
    id: crypto.randomUUID(),
    label: t("button-inline"),
    Icon: ButtonInlineIcon,
    key: MACRO_KEY.BUTTON_INLINE,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.FOOTNOTE_DISPLAY]: {
    id: crypto.randomUUID(),
    label: t("footnote-display"),
    Icon: TooltipAndFootnotesIcon,
    key: MACRO_KEY.FOOTNOTE_DISPLAY,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.ADVANCED_TABS_SINGLE]: {
    id: crypto.randomUUID(),
    label: t("advanced-tabs"),
    Icon: ButtonInlineIcon,
    key: MACRO_KEY.ADVANCED_TABS_SINGLE,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },
  [MACRO_KEY.OTHER_MODULES_KEY]: {
    id: crypto.randomUUID(),
    label: t("advanced-state.other-modules"),
    Icon: OtherModulesIcon,
    key: MACRO_KEY.OTHER_MODULES_KEY,
    category: MACRO_CATEGORIES.PAGE_BUILDER,
  },

  [MACRO_KEY.NEWS]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.news"),
    Icon: NewsIcon,
    key: MACRO_KEY.NEWS,
    category: MACRO_CATEGORIES.CONFLUENCE_CONTENT,
  },
  [MACRO_KEY.PAGES]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.pages"),
    Icon: PagesIcon,
    key: MACRO_KEY.PAGES,
    category: MACRO_CATEGORIES.CONFLUENCE_CONTENT,
  },
  [MACRO_KEY.SPACES]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.spaces"),
    Icon: SpacesIcon,
    key: MACRO_KEY.SPACES,
    category: MACRO_CATEGORIES.CONFLUENCE_CONTENT,
  },

  [MACRO_KEY.PEOPLE]: {
    id: crypto.randomUUID(),
    label: t("people"),
    Icon: PeopleIcon,
    key: MACRO_KEY.PEOPLE,
    category: MACRO_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  [MACRO_KEY.ORG_CHART]: {
    id: crypto.randomUUID(),
    label: t("org-charts"),
    Icon: OrgChartIcon,
    key: MACRO_KEY.ORG_CHART,
    category: MACRO_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  [MACRO_KEY.RECENTLY_ACTIVE]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.recently-active"),
    Icon: RecentlyActiveIcon,
    key: MACRO_KEY.RECENTLY_ACTIVE,
    category: MACRO_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  [MACRO_KEY.NEW_STARTERS]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.new-starters"),
    Icon: NewStartersIcon,
    key: MACRO_KEY.NEW_STARTERS,
    category: MACRO_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  [MACRO_KEY.UPCOMING_BIRTHDAYS]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.upcoming-birthdays"),
    Icon: UpcomingBirthdaysIcon,
    key: MACRO_KEY.UPCOMING_BIRTHDAYS,
    category: MACRO_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
  [MACRO_KEY.WORK_ANNIVERSARY]: {
    id: crypto.randomUUID(),
    label: t("overview.macros.work-anniversary"),
    Icon: WorkAnniversaryIcon,
    key: MACRO_KEY.WORK_ANNIVERSARY,
    category: MACRO_CATEGORIES.TEAMS_AND_ACTIVITY,
  },
});

export const ADVANCED_MACRO_KEYS = [
  MACRO_KEY.ADVANCED_TABS_GROUP,
  MACRO_KEY.ADVANCED_TABS_SINGLE,
  MACRO_KEY.BUTTON_INLINE,
  MACRO_KEY.PANEL_ADVANCED,
];

export const EDITOR_MACROS = (t) => {
  const macros = MACRO(t);
  return [
    macros[MACRO_KEY.OVERVIEW_KEY],
    macros[MACRO_KEY.CARDS],
    macros[MACRO_KEY.PANEL_SIMPLE],
    macros[MACRO_KEY.BUTTON],
    macros[MACRO_KEY.ANNOUNCEMENTS],
    macros[MACRO_KEY.COUNTDOWN],
    macros[MACRO_KEY.IMAGE_SLIDER],
    macros[MACRO_KEY.TEXT_AND_TITLE],
    macros[MACRO_KEY.SPACER_AND_DIVIDER],
    macros[MACRO_KEY.HTML],
    macros[MACRO_KEY.OTHER_MODULES_KEY],
    macros[MACRO_KEY.NEWS],
    macros[MACRO_KEY.PAGES],
    macros[MACRO_KEY.SPACES],
    macros[MACRO_KEY.PEOPLE],
    macros[MACRO_KEY.RECENTLY_ACTIVE],
    macros[MACRO_KEY.ORG_CHART],
    macros[MACRO_KEY.NEW_STARTERS],
    macros[MACRO_KEY.UPCOMING_BIRTHDAYS],
    macros[MACRO_KEY.WORK_ANNIVERSARY],
  ];
};

export const MACROS_WITHOUT_SIDEBAR = (t) => {
  const macros = MACRO(t);
  return [
    macros[MACRO_KEY.ADVANCED_TABS_GROUP],
    macros[MACRO_KEY.ADVANCED_TABS_SINGLE],
    macros[MACRO_KEY.PANEL_ADVANCED],
    macros[MACRO_KEY.TOOLTIPS_AND_FOOTNOTES],
    macros[MACRO_KEY.FOOTNOTE_DISPLAY],
    macros[MACRO_KEY.BUTTON_INLINE],
  ];
};

export const MACROS_WITHOUT_SETTINGS = (t) => {
  const macros = MACRO(t);
  return [
    macros[MACRO_KEY.HTML],
    macros[MACRO_KEY.OVERVIEW_KEY],
    macros[MACRO_KEY.OTHER_MODULES_KEY],
  ];
};

export const MACROS_REQUIRE_COSMOS = [
  MACRO_KEY.UPCOMING_BIRTHDAYS,
  MACRO_KEY.NEW_STARTERS,
  MACRO_KEY.WORK_ANNIVERSARY,
];
